<div class="host">
  <section class="banner-section width-wrapper">

    <h2 class="visually-hidden">Баннер</h2>
    <div class="left-side">
      <p class="banner-title">
        <span>Разрабатываем </span><span class="text-color">Инновационное </span>
        <span>отраслевое </span><span class="text-color">решение</span></p>

        <p class="banner-advantages">По цифровой трансформации турагентской деятельности <span class="br-footnote"><br></span>
      <span class="banner-footnote footnote-color">*</span><span class="banner-footnote footnote">При поддержке Фонда содействия инновациям</span>
      </p>

      <div class="advantages-wrapper">
        <ul class="advantages-list">
          <li class="advantages-list__item">
            Своя система поиска и сквозного бронирования туруслуг
          </li>
          <li class="advantages-list__item">
            Инструменты для сайта турагента
          </li>
        </ul>

        <ul class="advantages-list">
          <li class="advantages-list__item">
            CRM, ERP
          </li>
          <li class="advantages-list__item">
            ИИ-агенты
          </li>
        </ul>
      </div>

      <div class="banner-notebook">

        <div class="inner-wrap">

          <img class=""
               src="../../../assets/img/desktop-option-fav-sm.png"
               alt="Главная страница сервиса"
               width="701"
               height="403">
        </div>
      </div>

      <div class="online-wrapper">
        <span class="online-color">online</span>
        <p>управление агентством, продажами, взаимодействием с туристами</p>
      </div>

    </div>
  </section>
</div>
